import { createTheme } from '@mui/material/styles';

// Updated theme to match Figma design with mobile responsiveness
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  palette: {
    mode: 'light',
    primary: {
      main: '#0D5EBA', // Secondary/500 from Figma
      50: '#E3EFFC',
      600: '#034592',
      800: '#012657',
    },
    secondary: {
      main: '#667185', // Grey/500 from Figma
    },
    background: {
      default: '#FFFFFD', // Main background
      paper: '#FFFFFD',
    },
    grey: {
      50: '#F9FAFB',
      75: '#F7F9FC',
      100: '#F0F2F5',
      200: '#E4E7EC',
      300: '#D0D5DD',
      400: '#98A2B3',
      500: '#667185',
      700: '#344054',
      900: '#101928',
    },
    text: {
      primary: '#11121A', // Shade/Black
      secondary: '#344054', // Grey/700
    },
  },
  typography: {
    fontFamily: '"DM Sans", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    h5: {
      fontFamily: '"DM Sans", sans-serif',
      fontWeight: 600,
      fontSize: '20px',
      lineHeight: '120%',
      letterSpacing: '-0.02em',
      '@media (min-width:640px)': {
        fontSize: '24px',
      },
    },
    body1: {
      fontFamily: '"DM Sans", sans-serif',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '145%',
      '@media (min-width:640px)': {
        fontSize: '16px',
      },
    },
    body2: {
      fontFamily: '"DM Sans", sans-serif',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '145%',
      '@media (min-width:640px)': {
        fontSize: '14px',
      },
    },
    caption: {
      fontFamily: '"Inter", sans-serif',
      fontWeight: 400,
      fontSize: '9px',
      lineHeight: '145%',
      '@media (min-width:640px)': {
        fontSize: '10px',
      },
    },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: '8px',
          fontFamily: '"Inter", sans-serif',
          fontWeight: 600,
          fontSize: '12px',
          lineHeight: '145%',
          padding: '8px 16px',
          '@media (min-width:640px)': {
            fontSize: '14px',
            padding: '10px 20px',
          },
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '16px',
          paddingRight: '16px',
          '@media (min-width:640px)': {
            paddingLeft: '24px',
            paddingRight: '24px',
          },
        },
      },
    },
  },
});

export default theme; 